import {
  GET_COMPANIES_REQUEST,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: [],
  };
};

const initialState = getInitialState();

const companies = (state = initialState, action) => {
  const types = {
    [GET_COMPANIES_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_COMPANIES_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      data: action.response || [],
    }),
    [GET_COMPANIES_FAILURE]: () => ({
      ...state,
      isLoading: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default companies;
